<template>
  <div v-if="!privacyPolicyVisible && !isSbaComplete" class="w-100" :class="{ 'pt-10 mt-10 mt-lg-0': !portalLayout }">
    <MarketplaceWidgets class="d-lg-none" v-if="showWidgets"/>
    <client-only>
      <div class="px-3 px-lg-0 type-500 copyright">
        <hr class="d-none d-lg-block" />
        <p class="p-inline-xs">Copyright © {{ currentYear }} {{ tenantName }}. All Rights Reserved.  |  {{ address }}  |  <a class="type-500" :href=generalContactNumberLink>{{ generalContactNumber }}</a></p>
        <p class="p-inline-xs">California loans made pursuant to the California Financing Law, Division 9 (commencing with Section 22000) of the Finance Code. All such loans made through {{ californiaDisclaimerLegalName }} and a licensed finance lender/broker, California Financing Law License No. {{ californiaFinancingLawNumber }}.</p>
      </div>
    </client-only>
  </div>
  <div v-if="privacyPolicyVisible" v-html="privacyPolicyHtml" class="px-xl-0 px-5 mb-2 p-inline-xs" :class="{ 'pt-4': !portalLayout }"></div>
</template>

<script>
import MarketplaceWidgets from "~/components/marketplace/MarketplaceWidgets";
import { phone } from '~/libs/format'
import env from '~/libs/env'
import capitalize from 'lodash/capitalize'
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import {useProgressStore} from "~/store/progress";

export default {
  name: 'MarketplaceFooter',
  props: {
    portalLayout: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MarketplaceWidgets
  },
  data: () => ({
    currentYear: new Date().getFullYear(),
    generalContactNumber: phone(env('generalContactNumber')),
    generalContactNumberLink: 'tel:' + env('generalContactNumber'),
    tenantName: env('tenantName') ? capitalize(env('tenantName')) : 'Lendio',
    showWidgets: !env('tenantName'),
    californiaDisclaimerLegalName: env('californiaDisclaimerLegalName'),
    californiaFinancingLawNumber: env('californiaFinancingLawNumber'),
    address: env('address'),
  }),
  setup() {
    const isSbaComplete = useProgressStore()?.currentApp?.type === 'sba-complete'
    return { isSbaComplete }
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'privacyPolicyHtml',
      'privacyPolicyVisible',
    ]),
  }
}
</script>

<style lang="scss" scoped>
.copyright {
  @include media-breakpoint-up(lg) {
    max-width: 635px;
  }
}
</style>
